import type { BridgeRoom, BridgeTaskDetail } from '@/features/bridge';

export const getUserId = ({ sharedReducer: { userData } }: any): number => userData.id;

export const getIsBridgePlaylist = ({ playlistReducer }: any): boolean =>
	playlistReducer.isBridgePlaylist;

export const getPersonalityQuizAnswerIds = ({ playlistReducer }: any): number[] =>
	playlistReducer.personalityQuizAnswerIds;

export const getBridgeRoom = ({ bridgeReducer }: any): BridgeRoom | null => bridgeReducer.room;

export const getBridgeTask = ({ bridgeReducer }: any): BridgeTaskDetail | null =>
	bridgeReducer.task;
